import React from "react";
import Banner from "../../components/osportwear/home/banner";
import Header from "../../components/osportwear/layouts/header";
import Footer from "../../components/osportwear/layouts/footer";
import Category from "../../components/osportwear/home/category";
import ShopNow from "../../components/osportwear/home/shopnow";
import SecondBanner from "../../components/osportwear/home/secondbanner";

const HomePage = () => {
  return (
    <div className="container mx-auto bg-white">
      <Header />
      <Banner />
      <Category />
      <ShopNow title={"ShopNow"} />
      <SecondBanner />
      <ShopNow title={"BestSellers"} />
      <Footer />
    </div>
  );
};

export default HomePage;
